/**
 * Typed origin of content that may land in the org shared layer (L5
 * inc-knowledge / org-agents / packages/plugins).
 *
 * Single authority for this vocabulary (CLAUDE.md invariant #9). The
 * knowledge-submission carrier serializes it; L5 publish provenance
 * consumes the same enum. Do not re-declare the union on the server.
 *
 * Design-doc five layers (`docs/design/agent-session-memory-architecture-2026-08-25.md`):
 *   ① 个人本机私人记忆 — NOT a member of this vocabulary. Product rule: it
 *      must never enter any shared channel, so it has no corresponding enum
 *      value. Do not add one.
 *   ② 员工 L2 owner-only 记忆层 — `employee-memory`. May enter the shared
 *      layer only via the `submit_knowledge` review channel.
 */
export const CONTENT_ORIGINS = [
    "employee-memory",
    "project-memory",
    "session",
    "authored",
    "system",
    "unspecified",
];
/** Origins an employee may declare when submitting knowledge for review. */
export const SUBMITTED_CONTENT_ORIGINS = [
    "employee-memory",
    "project-memory",
    "session",
    "authored",
];
const CONTENT_ORIGIN_SET = new Set(CONTENT_ORIGINS);
const SUBMITTED_CONTENT_ORIGIN_SET = new Set(SUBMITTED_CONTENT_ORIGINS);
export function isContentOrigin(value) {
    return typeof value === "string" && CONTENT_ORIGIN_SET.has(value);
}
export function isSubmittedContentOrigin(value) {
    return typeof value === "string" && SUBMITTED_CONTENT_ORIGIN_SET.has(value);
}
//# sourceMappingURL=content-origin.js.map